import { Temporal, type Instant } from "@/Temporal"
import type { Nullable } from "@/models"
import { computed, ref } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../../IncidentLogHandler"
import EditableField from "../EditableField"
import EditAssetTime from "./EditAssetTime"

interface Props {
	value: Nullable<Instant>
	setValue(newValue: Nullable<Instant>): Promise<void>
}

const AssetTimeCell: ReactiveComponent<Props> = (props) => {
	const handler = useIncidentHandler()

	const editing = ref(false)
	const dateFormatted = computed(() => {
		const time = props.value
		if (!time) {
			return handler.readOnly ? "-" : ""
		}
		return handler.formatTime(time)
	})

	async function saveEdits(value: Nullable<Instant>) {
		await props.setValue(value)
		editing.value = false
	}

	return () => (
		<>
			<EditableField hasValue={props.value !== null} edit={() => (editing.value = true)}>
				<span class="flex items-center justify-center">{props.value ? dateFormatted.value : "-"}</span>
			</EditableField>
			{editing.value && (
				<EditAssetTime
					existing={props.value ?? Temporal.Now.instant()}
					cancel={() => (editing.value = false)}
					set={saveEdits}
				/>
			)}
		</>
	)
}

export default defineComponent(AssetTimeCell, inferProps<Props>())
